import React from "react"
import Card from "@material-ui/core/Card"
import CardMedia from "@material-ui/core/CardMedia"
import CardContent from "@material-ui/core/CardContent"
import Typography from "@material-ui/core/Typography"
import CardActions from "@material-ui/core/CardActions"
import Button from "@material-ui/core/Button"
import Image from "./image"
import ArrowRightAltIcon from "@material-ui/icons/ArrowRightAlt"

interface IProps {
  article: Article
}

interface Article {
  title: string
  image: string
  description: string
  url: string
  group?: string
  category?: string
}

const ArticleCard = ({ article }: IProps) => {
  const isIcon = [
    "calendar-alt-solid.png",
    "magic-ai-icon.png",
    "share-solid.png",
  ].includes(article.image)

  return (
    <Card>
      <CardMedia
        style={{
          height: 208,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
        }}
      >
        <Image
          alt={article.title}
          filename={article.image}
          style={{ width: isIcon ? 96 : "100%", height: isIcon ? 96 : "100%" }}
          imgStyle={{ objectFit: isIcon ? "contain" : "cover" }}
        />
      </CardMedia>
      <CardContent style={{ textAlign: "start" }}>
        {article.group && (
          <Typography variant="overline" color="primary">
            {article.group === "Activity routines"
              ? article.category
              : article.group}
          </Typography>
        )}
        <Typography variant="h6" component="h3" color="inherit">
          {article.title}
        </Typography>
        <Typography variant="body2" color="textSecondary" component="p">
          {article.description}
        </Typography>
      </CardContent>
      <CardActions style={{ paddingLeft: 20 }}>
        <Button size="small" color="primary" href={article.url || undefined}>
          Read More <ArrowRightAltIcon style={{ marginLeft: 5 }} />
        </Button>
      </CardActions>
    </Card>
  )
}

export default ArticleCard
